import React, { useState } from "react";

/**
 * Image with graceful fallback to a labeled blue placeholder if the source fails.
 * Used across the site to avoid broken-image icons.
 */
const SafeImage = ({ src, alt, label, className, style, loading = "lazy", ...rest }) => {
  const [errored, setErrored] = useState(false);

  if (errored) {
    return (
      <div
        className={className}
        style={{
          width: "100%",
          height: "100%",
          background:
            "linear-gradient(135deg, #1054d6 0%, #0b43a8 100%)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#fff",
          fontWeight: 600,
          fontSize: "0.95rem",
          letterSpacing: "0.02em",
          textAlign: "center",
          padding: 12,
          ...style,
        }}
        role="img"
        aria-label={alt || label || "Kontejner"}
      >
        {label || alt || "Kontejner"}
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      loading={loading}
      className={className}
      style={style}
      onError={() => setErrored(true)}
      {...rest}
    />
  );
};

export default SafeImage;
